import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ebb500a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "rl-box"
};
import { ref } from 'vue';
import SupportTrendChart from './SupportTrendChart.vue';
import SupportTrendFull from './SupportTrendFull.vue';
export default {
  __name: 'RateLineView',
  setup(__props, {
    expose: __expose
  }) {
    const list = ref([]);
    const fullRef = ref(null);
    const pushMatch = data => {
      list.value = (data || []).slice();
    };
    const zoom = () => {
      fullRef.value.show(list.value, 'had', '胜平负支持量走势');
    };

    // 暴露给外部使用的函数
    // eslint-disable-next-line no-undef
    __expose({
      pushMatch
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SupportTrendChart, {
        list: list.value,
        market: "had",
        height: "250px"
      }, null, 8, ["list"]), list.value.length ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "rl-zoom",
        onClick: zoom,
        title: "全屏查看"
      }, "⛶")) : _createCommentVNode("", true), _createVNode(SupportTrendFull, {
        ref_key: "fullRef",
        ref: fullRef
      }, null, 512)]);
    };
  }
};